import { LOAD_BILL } from '../actions/types';


export default function (state = [], action) {

    switch (action.type) {
        case LOAD_BILL:
            return action.payload;
        default: return state;
    }
}
